import logo from "../../../assets/images/logo-planejadora-vertical.png";
import logoSebrae from "../../../assets/images/logo-sebrae.png";
import { Link } from "react-router-dom";
import { BaSeIcon } from "@base/react";
import ChatLIS from "../../chat-lis";
import "./index.scss";
import { eventTag } from "../../../services/utils";
import moment from "moment";

const socials = [
  {
    link: "https://www.linkedin.com/company/sebrae/",
    title: "LinkedIn",
    iconName: "linkedin",
  },
  {
    link: "https://www.youtube.com/user/tvsebrae",
    title: "Youtube",
    iconName: "youtube",
  },
  {
    link: "https://www.instagram.com/sebrae/",
    title: "Instagram",
    iconName: "instagram",
  },
  {
    link: "https://www.facebook.com/sebrae",
    title: "Facebook",
    iconName: "facebook-f",
  },
];
const contact = {
  link: "tel:08005700800",
  text: "0800 570 0800",
};
const event = {
  name: "click-button",
  category: "footer",
  action: "click",
};

export default function Footer({ typeFooter = "guest" }) {
  return (
    <footer className={"footer type-" + typeFooter}>
      <div className="footer-top">
        {typeFooter === "guest" ? (
          <div className="container">
            <Link
              to="/"
              className="logo"
              onClick={() =>
                eventTag(event?.name, event?.category, event?.action, "Logo")
              }
            >
              <figure>
                <img src={logo} alt="Planejadora Sebrae" />
              </figure>
            </Link>
            <div className="phone">
              <p>Central de Relacionamento</p>
              <a
                href={contact?.link}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  eventTag(
                    event?.name,
                    event?.category,
                    event?.action,
                    contact?.text
                  )
                }
              >
                {contact?.text}
              </a>
            </div>
            <div className="download-socials-logo">
              <div className="download">
                <p>Baixe o App Sebrae</p>
                <ul className="apps">
                  <li>
                    <a
                      href="https://play.google.com/store/apps/details?id=br.com.sebrae.napalmadamao&hl=pt_BR"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        eventTag(
                          event?.name,
                          event?.category,
                          event?.action,
                          "Play Store"
                        )
                      }
                    >
                      <BaSeIcon
                        color="#005EB8"
                        description="Play Store"
                        name="logos/google-play-fill"
                        size={24}
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://apps.apple.com/br/app/sebrae/id1482839375"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        eventTag(
                          event?.name,
                          event?.category,
                          event?.action,
                          "IOS"
                        )
                      }
                    >
                      <BaSeIcon
                        color="#005EB8"
                        description="IOS"
                        name="apple"
                        size={24}
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <ul className="socials">
                {socials.map((social, index) => (
                  <li key={index}>
                    <a
                      href={social?.link}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        eventTag(
                          event?.name,
                          event?.category,
                          event?.action,
                          social?.title
                        )
                      }
                    >
                      <BaSeIcon
                        color="#005EB8"
                        description={social?.title}
                        name={social?.iconName}
                        size={24}
                      />
                    </a>
                  </li>
                ))}
              </ul>
              <a
                href="https://sebrae.com.br/sites/PortalSebrae"
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  eventTag(event?.name, event?.category, event?.action, "Logo")
                }
                className="logo"
              >
                <figure>
                  <img src={logoSebrae} alt="Planejadora Sebrae" />
                </figure>
              </a>
            </div>
          </div>
        ) : (
          <>
            <a
              className="link-button"
              href="https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos"
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                eventTag(
                  event?.name,
                  event?.category,
                  event?.action,
                  "Conheça o Sebrae"
                )
              }
            >
              <span>Conheça o Sebrae</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="currentColor"
              >
                <path
                  d="M14.8297 11.5397L10.5897 7.2997C10.4019 7.11039 10.1463 7.00391 9.8797 7.00391C9.61306 7.00391 9.35747 7.11039 9.1697 7.2997C8.78198 7.68974 8.78198 8.31967 9.1697 8.7097L12.7097 12.2497L9.1697 15.7897C8.78198 16.1797 8.78198 16.8097 9.1697 17.1997C9.35842 17.3869 9.6139 17.4912 9.8797 17.4897C10.1455 17.4912 10.401 17.3869 10.5897 17.1997L14.8297 12.9597C15.019 12.7719 15.1255 12.5163 15.1255 12.2497C15.1255 11.9831 15.019 11.7275 14.8297 11.5397Z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <div className="container">
              <div className="phone">
                <p>Central de Relacionamento</p>
                <a
                  href={contact?.link}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    eventTag(
                      event?.name,
                      event?.category,
                      event?.action,
                      contact?.text
                    )
                  }
                >
                  {contact?.text}
                </a>
              </div>
              <ul className="socials">
                {socials.map((social, index) => (
                  <li key={index}>
                    <a
                      href={social?.link}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        eventTag(
                          event?.name,
                          event?.category,
                          event?.action,
                          social?.title
                        )
                      }
                    >
                      <BaSeIcon
                        color="#005EB8"
                        description={social?.title}
                        name={social?.iconName}
                        size={24}
                      />
                    </a>
                  </li>
                ))}
              </ul>
              <ChatLIS />
            </div>
          </>
        )}
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>Planejadora Sebrae © {moment().format('YYYY')}. Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
}
